import { Reveal } from "@/lib/motion";
import { Chapter } from "./Chapter";
import { WRITING } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Writing = () => (
  <section id="writing" className="relative z-10 py-24 md:py-32 lg:py-40">
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
      <Chapter num="07" title="Selected writing" kicker="Field notes & reflections" />

      <div className="border-t border-[#d2d5ce]">
        {WRITING.map((w, i) => (
          <Reveal key={w.slug} delay={i * 0.06}>
            <Link
              to={`/writing/${w.slug}`}
              data-testid={`writing-link-${w.slug}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-9 md:py-11 border-b border-[#d2d5ce] hover:border-[#16324f] transition-colors duration-500"
            >
              <div className="md:col-span-3 flex md:flex-col items-baseline md:items-start justify-between gap-3">
                <span className="font-mono-plex text-[13.5px] uppercase tracking-[0.16em] text-[#b5423a]">
                  {w.tag}
                </span>
                <span className="font-mono-plex text-[13.5px] text-[#2e7d6b] tracking-wide">
                  {w.meta}
                </span>
              </div>
              <div className="md:col-span-8">
                <h3 className="font-serif-display text-2xl md:text-[30px] text-[#16324f] leading-tight group-hover:translate-x-1 transition-transform duration-500">
                  {w.title}
                </h3>
                <p className="mt-3 text-[16px] md:text-[17px] text-[#3a4d5c] leading-relaxed max-w-2xl">
                  {w.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 font-mono-plex text-[12.5px] uppercase tracking-[0.14em] text-[#16324f]">
                  Read <span className="text-[#48606f]">· {w.readTime}</span>
                </span>
              </div>
              <div className="md:col-span-1 flex md:justify-end items-start">
                <ArrowUpRight
                  size={22}
                  strokeWidth={1.4}
                  className="text-[#16324f] opacity-40 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-400"
                />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
